import { fromPythonTS } from 'utils/time'

import {
    STRONGHOLD_MANEUVERS_REQUEST,
    STRONGHOLD_MANEUVERS_SUCCESS,
    STRONGHOLD_MANEUVERS_ERROR,
} from 'state/actions/stronghold_maneuvers'

export const initialState = {
    loading: false,
    loaded: false,
    error: false,
    visibleStartDate: 0,
    visibleEndDate: 0,
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case STRONGHOLD_MANEUVERS_REQUEST:
        return {
            ...state,
            loading: true,
            error: false,
        }
    case STRONGHOLD_MANEUVERS_SUCCESS: {
        const { event_config } = action.payload
        const { visible_start_date, visible_end_date } = (event_config || {})

        return {
            ...state,
            visibleStartDate: fromPythonTS(visible_start_date),
            visibleEndDate: fromPythonTS(visible_end_date),
            loaded: true,
            loading: false,
            error: false,
        }
    }
    case STRONGHOLD_MANEUVERS_ERROR:
        return {
            ...state,
            error: true,
        }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/stronghold_maneuvers.js